export const MOCK_VENDORS = [
  {
    id: 1,
    name: "Acme Transport",
    contact_email: "admin@acmetransport.com",
    active: true,
    user_count: 12,
    date_created: "2025-06-15T10:30:00Z",
    date_changed: "2026-01-20T14:00:00Z"
  },
  {
    id: 2,
    name: "Metro Shuttle Services",
    contact_email: "ops@metroshuttle.com",
    active: true,
    user_count: 8,
    date_created: "2025-08-22T09:00:00Z",
    date_changed: "2026-01-18T11:30:00Z"
  }
];
